import styled from 'styled-components';
import { StyledAdminUsersRowsWidth } from '../../AdminEditUsers/styles';
import { StyledAdminListRow } from '../../AdminListHeaderCell/styles/StyledAdminListRow';

export const StyledAdminUsersListRow = styled.div`
  ${StyledAdminListRow}

  .admin-list-cell-container {
    ${StyledAdminUsersRowsWidth}
  }

  @media screen and (max-width: 1100px) {
    width: 110rem;
  }
`;
